import Vue from 'vue'
import Vuetify, { VLayout, VCombobox, VAutocomplete, VMenu, VBtn, VCard, VChip, VDatePicker, VTextField } from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'
Vue.use(Vuetify, {
    iconfont: 'liga', // 'md' || 'mdi' || 'fa' || 'fa4'
    theme: {
        primary: '#143860',
        secondary: '#4275AE',
        tertiary: '#6D6D6D',
        warning: colors.amber.accent4
    },
    components: {
        VLayout,
        VCombobox,
        VAutocomplete,
        VMenu,
        VBtn,
        VCard,
        VChip,
        VDatePicker,
        VTextField
    }
})
